import {Component, EventEmitter, Inject, OnInit} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
    selector: 'information-dialog',
    templateUrl: './information.dialog.html',
    styleUrls: ['./all-dialog.scss']
})
export class InformationDialog implements OnInit {
    public result = new EventEmitter();

    constructor(
        public dialogRef: MatDialogRef<InformationDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
    }

    async ngOnInit(): Promise<void> {

    }

    closeDialog() {
        this.dialogRef.close();
    }

    ok() {
        this.result.emit(true);
        this.closeDialog();
    }
}
